import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { MappingCell, YesNoCell, DateCell, CellFunction } from '../../cells';
import { IEpxDialysis } from '../../../../../libs/apps/epxdialysis';

const EpxDialysisTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxDialysis>[] = [
    {
      Header: 'Dialysis Date',
      id: 'sessionAt',
      Cell: ResponseGuard(DateCell('sessionAt') as CellFunction<IEpxDialysis>)
    },
    {
      Header: 'Prompt',
      id: 'isInteractive',
      Cell: ResponseGuard(
        YesNoCell('isInteractive') as CellFunction<IEpxDialysis>
      )
    },
    {
      Header: 'Attendance',
      id: 'attendance',
      Cell: ResponseGuard(
        MappingCell('attendance', {
          1: 'Yes',
          [-1]: 'No',
          0: 'Late'
        }) as CellFunction<IEpxDialysis>
      )
    }
  ];
  return (
    <SessionTable<IEpxDialysis>
      url="/epxdialysis/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxDialysisTable;
